import { render, staticRenderFns } from "./VehicleImport.vue?vue&type=template&id=15b12722"
import script from "./VehicleImport.vue?vue&type=script&lang=js"
export * from "./VehicleImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports